const autoNgTemplateLoaderTemplate1 = require('./kube-create-custom-template-view.html');

import controller from './kube-create-custom-template-view.controller.js';

export const kubeCreateCustomTemplateView = {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
};
